import type { OpenDeleteDialog } from './typings'

export const openDeleteDialogActionCreator = (
  payload: string,
): OpenDeleteDialog => ({
  type: 'activityTypes/openDeleteDialog',
  payload,
})
